window.addEventListener("pageshow", function (event) {
	if (typeof pageTransition.enter === 'function') {
		if (firstLoad) {
			firstLoad = false;
		} else {
			pageTransition.enter(function () {
				$(window).trigger('transitionDone');
			});
		}
	}
});